/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyContactHistoryModel } from '../../models/client-survey-contact-history-model';
import { CreateSurveyContactHistoryRequest } from '../../models/create-survey-contact-history-request';

export interface CreateSurveyContactHistoryAsync$Json$Params {
  
    /**
     * properties of surveycontacthistory item to create
     */
    body?: CreateSurveyContactHistoryRequest
}

export function createSurveyContactHistoryAsync$Json(http: HttpClient, rootUrl: string, params?: CreateSurveyContactHistoryAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactHistoryModel>> {
  const rb = new RequestBuilder(rootUrl, createSurveyContactHistoryAsync$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyContactHistoryModel>;
    })
  );
}

createSurveyContactHistoryAsync$Json.PATH = '/api/SurveyContactHistory';
